import React from "react";
import { useAuth } from "../context/AuthContext";

const DiscordLoginButton = () => {
  const { user, loading } = useAuth();

  if (loading) return null;
  if (user) return null;

  const handleLogin = () => {
    const isLocalDev =
      window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1";

    window.location.href = isLocalDev
      ? "http://localhost:5000/api/auth/discord/login"
      : "/api/auth/discord/login";
  };

  return (
    <div className="discord-login-footer">
      <button
        type="button"
        className="discord-login-button"
        onClick={handleLogin}
      >
        LOGIN
      </button>
    </div>
  );
};

export default DiscordLoginButton;